import TableLoadingSpinner from '@/components/ui/table/TableLoadingSpinner';

import { useSearchParams } from 'react-router-dom';
import SearchResult from '../SearchResult';
import { useSearchResults } from './searchResultsHooks';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const { events, isLoading } = useSearchResults();

  return (
    <section className='w-full h-full box-border overflow-y-auto border-t border-[#001326]'>
      {!searchParams && (
        <div className='w-full h-full flex items-center justify-center text-3xl text-[#00000060]'>
          Search Event
        </div>
      )}

      {searchParams && isLoading && (
        <TableLoadingSpinner width={'3rem'} height={'3rem'} />
      )}

      {searchParams && !isLoading && events.length === 0 && (
        <div className='w-full h-full flex items-center justify-center text-3xl text-[#00000060]'>
          No Event Found
        </div>
      )}

      {searchParams &&
        !isLoading &&
        events.length > 0 &&
        events.map((event, index) => (
          <SearchResult key={index} event={event} />
        ))}
    </section>
  );
};

export default SearchResults;
